"use client";

import { usePathname } from "next/navigation";
import styles from "./ProgramBanner.module.scss"
import cn from "clsx";
import Markdown from "@/components/atoms/Markdown";
import CommonButton from "@/components/common/Analytics/CustomButton";
import { GAEvent, GA_EVENTS, GA_EVENTS_PAYLOAD, IGAEvent, ga_events_mapping } from "@/helpers/gaEvents";
import { useEffect, useState, useRef } from "react";
import { StorageService } from "@/helpers/storage.service";
import { ModalTypes, IModalActions } from "@/types/modal";
import {
  OTPContext,
  OTPContextProvider,
  OTPContextWrapper,
} from "@/components/sections/CommonModals/context";
import ProgramDetailsConnectModalForm from "../Forms/ProgramPageConnectModalForm/ProgramPageConnectModalForm";
import { getGlobalStateValue, updateStateSession } from "@/context/utils";
import { pushToDataLayer } from "@/helpers/gtag";
import { imgPathReplace } from "@/helpers/imgPathReplace";
import shareIcon from "~/icons/share.png"
import { useModalDispatch } from "@/context/ModalContext";
import { FREEZE_RFIS } from "@/components/organisms/HeaderOpt/utils";
import Image from "next/image";
import useOnScreen from "@/helpers/Onscreen";
import ImageTag from "../BannerWithImageNew/TagView/ImageTag";
import LandingConnectModalFormMBA from "@/LpRevamp/LandingPageConnectModalMBA/LandingConnectModalFormMBA";


interface ProgramBannerProps {
  BannerData: any;
  isMobile: boolean;
  fetchPriority?: "auto" | "high";
  specializationText: string;
  Custom10PgType?: string;
  associatedPrograms: Array<ProgramDetails>;
  ProgramId: string;
  NewBannerUI: NewBannerUI;
  isSeatsFilledEnabled?: boolean;
  Numbers: number;
  isLambdaApi?: boolean;
  LandingPageBrochure?: any;
  isMbaPage?: boolean;
  isNextGen?:boolean
  tagText?: string;
  SponsoredText?: string;
  NewBannerImage?:NewBannerImage;
  slug?:string;
}




export default function ProgramBanner({
  BannerData,
  isMobile,
  fetchPriority = "auto",
  specializationText,
  Custom10PgType = "",
  associatedPrograms,
  ProgramId,
  NewBannerUI,
  isSeatsFilledEnabled,
  Numbers,
  tagText,
  SponsoredText,
  NewBannerImage,
  isLambdaApi,
  slug,
  LandingPageBrochure
}: ProgramBannerProps) {
  const [leadFailed, setLeadFailed] = useState(false);
  const modalDispatch = useModalDispatch();
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0
  });

  const ref = useRef<HTMLDivElement>(null);
  const onScreen = useOnScreen(ref);

  const isLeadFailed = (status:boolean)=>{
    setLeadFailed(status)
  }
  const pathName = usePathname();
  const [clickedInsideLeadForm, setClickedInsideLeadForm] = useState(false);

  const {
    PROGRAM_TAB_DOWNLOAD_BROCHURE,
    PROGRAM_CARD_DOWNLOAD_BROCHURE,
    PROGRAM_DOWNLOAD_BROCHURE,
    LEAD_INITIATE
  } = GAEvent;
  const [gaData, setGaData] = useState<IGAEvent | null>(null);

  function getGaSessionData(): {
    isMbaPage?: boolean;
    isNavbarClick?: boolean;
  } | null {
    return StorageService.get("programDetailsGAInfo") ?? {};
  }

  useEffect(() => {
    updateStateSession({
      formSectionName: "Download Brochure",
      leadStartingCta: BannerData?.CTA?.text || "NA"
    });
  }, []);
  useEffect(() => {
    const enrollNowRefProgram=document.getElementById("enroll-now-cta");

    if ( enrollNowRefProgram ) {
      if (onScreen) {
        enrollNowRefProgram.style.display="none"
      } else {
        enrollNowRefProgram.style.display="flex"
      }
    }
  }, [onScreen]);

     useEffect(() => {
       const enrollNowRef = document.getElementById("botton-nav-container");

       if (enrollNowRef ) {
         if (onScreen) {
           enrollNowRef.style.display = "none";
         } else {
           enrollNowRef.style.display = "flex";
         }
       }
     }, [onScreen]);


  useEffect(() => {
    try {
      const { isMbaPage = false, isNavbarClick } = getGaSessionData();
      if (ga_events_mapping?.[pathName] || isMbaPage) {
        let data: any;
        if (isNavbarClick !== undefined) {
          data = {
            ...GA_EVENTS_PAYLOAD.get(
              isNavbarClick ? PROGRAM_TAB_DOWNLOAD_BROCHURE : PROGRAM_CARD_DOWNLOAD_BROCHURE
            ),
            pageType: isNavbarClick ? "Program Nav" : "Program Card",
          };
        } else {
          data = {
            ...GA_EVENTS_PAYLOAD.get(PROGRAM_DOWNLOAD_BROCHURE),
            pageType: "Program Details",
          };
        }
        setGaData(data);
      }
    } catch (error) {
      console.error("Error parsing programDetailsGAInfo from sessionStorage", error);
    }
  }, []);


  const handleClickInsideLeadForm = (e) => {
    if (!clickedInsideLeadForm) {
      StorageService.set("timeConnectModal", true)

      pushToDataLayer(
        {
          event: "lead_initiate",
          cta_text: "NA",
          section_name: "hero_banner",
          header_title: BannerData?.Heading?.text || "NA",
          page_type: "Program Page",
          page_url: window.location.href || "NA"
        }
      )
      updateStateSession(
        {
          parentSection: "hero_banner"
        }
      )
      setClickedInsideLeadForm(true);
    }
  };

  const handleShare = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ShareIcon,
        modalData: { programTitle: BannerData?.Heading?.text },
      },
    });
    setTimeout(() => {
      pushToDataLayer({
        event: `share_initiate`,
        cta_text: `Share`,
        section_name: "hero_banner",
        page_type: getGlobalStateValue("pageType"),
        page_url: location.href,
        header_title: BannerData?.Heading?.text,
      });
    }, 2500);
  }

  const handleClickOutsideLeadForm = (e) => {
    const formElement = document.getElementById("new-lead-form");
    if (formElement && !formElement.contains(e.target)) {
      setClickedInsideLeadForm(false); // Reset if clicked outside
    }
  };

  // Add event listener for clicks outside the open lead form
  useEffect(() => {
    document.addEventListener("click", handleClickOutsideLeadForm);
    return () => {
      document.removeEventListener("click", handleClickOutsideLeadForm);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    if (typeof window !== 'undefined') {
      handleResize(); // initial value
      window.addEventListener('resize', handleResize);
    }
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, []);

  const newurl = imgPathReplace(NewBannerUI?.bannerImage?.data?.attributes.url);
  const sponsorSubtitle = "Post successful completion, apply for paid internship *";
  const programDetails = associatedPrograms[0]?.attributes?.BasicDetails
  const brochure =  LandingPageBrochure?.data?.attributes?.url
  return (
    <div className="container">
      <div
        className={cn(styles.BannerImage__container, styles.BannerImage__container, pathName?.includes("ma-in-psychology") && styles.BannerImage__containerPsychology)}
        style={windowSize.width > 0 && windowSize.width > 768 ? {
          background: `url(${imgPathReplace(newurl)}) no-repeat`,
          backgroundPosition: "50% center",
          backgroundSize: "cover"
        } : null}
      >
        {/* Left section with box shadow for blue */}
        <div className={cn( styles.BannerImage__leftContainer,styles.BannerImage__leftContainer, "text-primary-blue")}
          style={windowSize.width > 0 && windowSize.width < 769 ? {
            background: `url(${imgPathReplace(newurl)}) no-repeat`,
            backgroundPosition : "30% center",
        backgroundSize: "cover",
      } : null}
        >
          {/* Upper subtitle and title section */}
          {/* Subtitle */}
          <div className={styles.mainContent} style={!isMobile && NewBannerUI.tagTextHTML ? { minHeight: 0 } : {}}>
            {BannerData?.ProgramType?.enabled ? (
              <p style={{ color: 'white' }} className={cn(styles.BannerImage__subtitle, "uppercase")}>
                {BannerData?.ProgramType?.text}
              </p>
            ) : null}
            {/* Title */}
            {BannerData?.Heading?.enabled ? (
              <Markdown as="h1" id = "programpage-heading" className={cn(styles.BannerImage__title)}>
                {BannerData?.Heading?.text.replace(/^#\s+(.*)$/gm, "$1")}
              </Markdown>
            ) : null}
            {BannerData?.Sponsor?.enabled && (
                    <div className={cn(styles.sponsor)}>
                      <div>
                        <h6>{BannerData?.Sponsor?.Title}</h6>
                      </div>
                      <div>
                        <img
                          src={BannerData?.Sponsor?.Image?.data?.attributes?.url}
                          alt={BannerData?.Sponsor?.Image?.data?.attributes?.alternativeText}
                          loading="lazy"
                        />
                      </div>
                    </div>
                  )}
                <div>
                  {SponsoredText?.length>0  &&
                  <p className={styles.tagTextWrapper}>
                   {SponsoredText}</p>
                   }
                  
                </div>
            
             {BannerData?.Duration?.enabled && (
              <div className={styles.durationWrapper}>
                <p className={cn(styles.BannerImage__duration, "uppercase")}>
                  <span className={cn(styles.BannerImage__durationLabel)}>Duration:</span>{" "}
                  {BannerData?.Duration?.text}
                </p>
              </div>
            )}
            {/* CTA */}
            {BannerData?.CTA?.enabled && !isMobile && !FREEZE_RFIS.includes(pathName) && (
              <>
                <div className={cn(styles.BannerImage__cta)}>
                  <div className='flex gap-2'>
                    <CommonButton
                    id="download-brochure-btn"
                      onClickStorePayload={
                        {
                          sectionTitle: "Hero Banner",
                          parentSection: "hero_banner"
                        }
                      }
                      GAData={gaData}
                      GADataNew={{
                        ...GA_EVENTS.get(LEAD_INITIATE),
                        cta_text: BannerData?.CTA?.text,
                        section_name: "hero_banner",
                        header_title: BannerData?.Heading?.text || "NA",
                        isPageType: true,
                        page_url: true
                      }}
                      isEventOnly={true}
                      CTATarget="_self"
                      programTitle={BannerData?.Heading?.text}
                      type={"button"}
                      modalType={ isLambdaApi ? ModalTypes.DownloadBrochureLP:ModalTypes.DownloadBrochure}
                      scroll={false}
                      color="#ffc907"
                      icon="/_a/icons/left-arrow-blue-down.svg"
                      hoverIcon="/_a/icons/left-arrow-blue-down.svg"
                      modalData={{ specializationText, Custom10PgType,programDetails,brochure }}
                      className={styles.BannerImage__CTAStyle}
                      webEngageEvent={{ eventName: "Download Brochure Clicked" }}
                    >
                      {BannerData?.CTA?.text}
                    </CommonButton>
                    <div className={styles.shareIconDiv} onClick={handleShare} id="PP-share-icon">
                      <Image height={20} width={20} src={shareIcon.src} alt="shareIcon"/>
                    </div>
                  </div>
                </div>
              </>
            )}
            {BannerData?.CTA?.enabled && isMobile && !FREEZE_RFIS.includes(pathName) && (
              <>
                <div className={cn( styles.BannerImage__cta)}>
                  <div className='flex gap-2'>
                    <CommonButton
                    id="download-brochure-btn"
                      GAData={gaData}
                      CTATarget="_self"
                      isEventOnly
                      GADataNew={{
                        ...GA_EVENTS.get(LEAD_INITIATE),
                        cta_text: BannerData?.CTA?.text,
                        section_name: "hero_banner",
                        header_title: BannerData?.Heading?.text || "NA",
                        isPageType: true,
                        page_url: true
                      }}
                      onClickStorePayload={
                        {
                          parentSection: "hero_banner"
                        }
                      }
                      webEngageEvent={{ eventName: "Download Brochure Clicked" }}
                      programTitle={BannerData?.Heading?.text}
                      type={"button"}
                      modalType={ isLambdaApi ? ModalTypes.DownloadBrochureLP:ModalTypes.DownloadBrochure}
                      scroll={false}
                      color="#ffcc00"
                      icon="/_a/icons/left-arrow-blue-down.svg"
                      hoverIcon="/_a/icons/left-arrow-blue-down.svg"
                      modalData={{ specializationText, Custom10PgType,programDetails,brochure }}
                      className={styles.BannerImage__CTAStyle}
                    >
                      {BannerData?.CTA?.text}
                    </CommonButton>
                    <div className={styles.shareIconDiv} onClick={handleShare} id="PP-share-icon">
                      <img height={20} width={20} src={shareIcon.src}></img>
                    </div>
                  </div>
                </div>
              </>
            )}
            <p className="text-[10px] text-white mt-2">{tagText}</p>
          </div>
        </div>
        {NewBannerImage?.data && 
        <div className={styles.middleContainer}>
        <img src={NewBannerImage?.data?.attributes?.url} alt="BannerImage" />
     </div>
        }
        

        {/* Right section with image */}
        {!FREEZE_RFIS.includes(pathName) && <div ref={ref} id="new-lead-form" className={`${styles.leadFormWrapper} ${styles.leadFormWrapperImmersion} `} onClick={handleClickInsideLeadForm}>
          <OTPContextProvider isLambdaAPI={isLambdaApi}>
            <OTPContext.Consumer>
              {({ isHeaderHidden }) => (
                <>
                  {!isHeaderHidden && !isLambdaApi && (
                    <Markdown as="h2" className={styles.formHeading} id="form-heading">
                      Apply Now
                    </Markdown>
                  )}
                  <OTPContextWrapper  isLambdaAPI={isLambdaApi}>
                    {
                      isLambdaApi ? <LandingConnectModalFormMBA
                                              associatedPrograms={associatedPrograms}
                                              slug={slug}
                                            />:
                                            <ProgramDetailsConnectModalForm
                       ProgramId={ProgramId} associatedPrograms={associatedPrograms}  isNewLeadForm={true}
                                            NewBannerUI={NewBannerUI}
                                            isMobile={isMobile}
                                            setLeadFailed={isLeadFailed}
                                            isSeatsFilledEnabled={isSeatsFilledEnabled}
                                            Numbers={Numbers}
                                          />
                    }

                  </OTPContextWrapper>
                </>
              )}
            </OTPContext.Consumer>
          </OTPContextProvider>
          
        </div>}
      </div>
    </div>
  );
}
